import { hFetch } from '@/lib/hfetch';
import type { ContactRecordType } from '../entity_types/Contact';
import type { PipelineReviewType } from '../entity_types/PipelineReview';

export type AgentCurrentResponse = {
  record_type: ContactRecordType;
  pipeline_review_type: PipelineReviewType;
};
export const getCurrent = async () => {
  return await hFetch<AgentCurrentResponse>({
    url: '/api/agent/current',
  });
};
